var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('DimensionModel'),_vm._v(" "),_c('TableNormal'),_vm._v(" "),_c('TableDetail'),_vm._v(" "),_c('lineModel'),_vm._v(" "),_c('rengeModel'),_vm._v(" "),_c('hobbyModel'),_vm._v(" "),_c('classScore'),_vm._v(" "),_c('totalScore'),_vm._v(" "),_c('latitudeRadar'),_vm._v(" "),_c('characteristics')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-160e015d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/models.vue
// module id = MhsF
// module chunks = 0